import HeroSection from './components/HeroSection';
import WhatWeDo from './components/WhatWeDo';
import WhyMarketMe from './components/WhyMarketMe';
import FreeAudit from './components/FreeAudit';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import ContactForm from './components/ContactForm';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navigation />
      <HeroSection />
      <WhatWeDo />
      <WhyMarketMe />
      <FreeAudit />
      <Footer />
      <ContactForm />
    </div>
  );
}
